const projectRoleSelector = state => state.roles.project.roles
const isProjectLoadedSelector = state => state.roles.project.isLoaded
const projectIdSelector = state => state.roles.project.id

export {
  projectRoleSelector,
  projectIdSelector,
  isProjectLoadedSelector,
}
